import { FunctionComponent } from 'react';
import { ParsedPromo } from '../../Layout/Promotions/types';
import { GameCardContainerType } from '../../Games/GameCard/GameCard.types';
import { ItvPromoCardTall } from './ItvPromoCardTall';
import { useBrandedNavigate } from '../../../hooks/useBrandedNavigate';

import { RowCollectionLayout } from '../ItvRowCollection/layouts/types';
import { ItvPromoCardRect } from './ItvPromoCardRect';

export const ItvPromoCard: FunctionComponent<{
  promo: ParsedPromo;
  type: GameCardContainerType;
  isWide: boolean;
  handleClaimClick?: (promo?: ParsedPromo) => void;
  layout?: RowCollectionLayout;
}> = ({ promo, type, handleClaimClick, layout }): JSX.Element => {
  const { navigate, activeBrand } = useBrandedNavigate();
  const goToPromoPage = (): void => navigate(String(`/${activeBrand}${promo.pageUrl}`));

  return (
    <div>
      {type === GameCardContainerType.Tall ? (
        <ItvPromoCardTall promo={promo} goToPromoPage={goToPromoPage} />
      ) : (
        <ItvPromoCardRect
          handleClaimClick={handleClaimClick}
          promo={promo}
          goToPromoPage={goToPromoPage}
          layout={layout}
        />
      )}
    </div>
  );
};
